import React, { ReactNode } from "react";
import "./CreateLayout.scss";
import { Button } from "primereact/button";
import { FaArrowLeftLong } from "react-icons/fa6";

interface CreateLayoutProps {
  sidebarChildren?: ReactNode;
  contentChildren: ReactNode;
  title: string;
  goBack: any;
}

export default function CreateLayout({
  sidebarChildren,
  contentChildren,
  title,
  goBack,
}: CreateLayoutProps) {
  return (
    <section className="create-layout">
      <div className="header">
        <Button rounded className="default" onClick={() => goBack()}>
          <FaArrowLeftLong />
        </Button>
        <h2>{title}</h2>
      </div>
      <div className="form-layout">
        {sidebarChildren && (
          <div className="create-sidebar">{sidebarChildren}</div>
        )}
        <div className="create-content">{contentChildren}</div>
      </div>
    </section>
  );
}
